import React, { useMemo, useState } from 'react'
import { NotificationManager } from 'react-notifications'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import orderService from '../../../../services/orderService'
import retailService from '../../../../services/retailService'
import { orderTransformerV2, ordersText } from '../../../../views/delivery/orders'
import UpdateOrderStatusModal from '../../../../views/delivery/orders/update-order-status-modal'
import { columnsRenderTable } from '../../../../views/delivery/tables/columns'
import AreYouSureModal from '../../../common/areYouSureModal'
import GenericPagination from '../../../generic-table/generic-pagination'
import GenericTable from '../../../generic-table/generic-table'
import { OrdersColumns } from './data'

const OrdersTable = ({ data = [], setData }) => {
	const navigate = useNavigate()

	const { short_code } = useSelector((state) => state.app);
	const isBBShop = short_code === "BYB2929SCDE";

	const [page, setPage] = useState(0)
	const [rowsPerPage, setRowsPerPage] = useState(10)
	const [orderSelected, setOrderSelected] = useState();
	const [isAreYouSureDeleteModalOpen, setAreYouSureDeleteModalOpen] =
		useState(false);
	const [isUpdateStatusModalOpen, setIsUpdateStatusModalOpen] = useState();

	const [orderId, setOrderId] = useState(-1)

	const onAction = (id) => {
		navigate(`/${short_code}/admin/delivery/order/${id}`)
	}

	const handleChangePage = (_, newPage) => {
		setPage(newPage)
	}

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(event)
		setPage(0)
	}

	const onDelete = (id) => {
		setOrderId(id)
		setAreYouSureDeleteModalOpen(true)
	}

	const onEdit = (id) => {
		setOrderSelected(id)
		setIsUpdateStatusModalOpen(true)
	}

	const handleDeleteOrder = () => {
		orderService.DeleteOrder(orderId)
			.then(({ res }) => {
				// Update the data by filtering out the deleted order
				setData(data.filter((item) => item.id !== orderId))
				NotificationManager.success(res?.message ?? "Order deleted successfully");
			})
			.catch(err => {
				NotificationManager.error(err?.error ?? "Something went wrong!");
			})
	}

	const handleStatusUpdate = (orderStatus) => {
		const payload = {
			status: orderStatus,
		}

		retailService.ChangeOrderStatus(orderSelected.id, payload)
			.then(({ res }) => {
				// Update the data by mapping through it and updating the status
				const updatedData = data.map((item) => {
					if (item.id === orderSelected.id) {
						return { ...item, status: orderStatus };
					}
					return item;
				});

				setData(updatedData);
				NotificationManager.success(res?.message ?? "Status changed successfully");
			})
			.catch(err => {
				NotificationManager.error(err?.error ?? "Something went wrong!");
			})
	}

	// const onDelivery = () => {
	// 	// Implementation for delivery action
	// }

	// Use the same columnsRenderTable function that works correctly in other components
	const BBShopColumns = columnsRenderTable(orderTransformerV2, true, true);

	const BBShopActions = isBBShop ? {
		onView: (item) => onAction(item.id),
		onTrash: onDelete,
		onEdit: onEdit,
		// onDelivery: onDelivery,
	} : {};

	const displayedData = useMemo(() => {
		const start = page * rowsPerPage
		const end = start + rowsPerPage
		return data.slice(start, end)
	}, [data, page, rowsPerPage])

	return (
		<>
			{isBBShop ? (
				<GenericTable
					columns={BBShopColumns}
					data={displayedData} // Don't transform the data, use it directly
					{...BBShopActions}
				/>
			) : (
				<GenericTable
					columns={OrdersColumns}
					data={displayedData}
				/>
			)}

			<GenericPagination
				rowsPerPage={rowsPerPage}
				page={page}
				setPage={setPage}
				onRowsPerPageChange={handleChangeRowsPerPage}
				count={data.length}
				onPageChange={handleChangePage}
			/>

			{isAreYouSureDeleteModalOpen && (
				<AreYouSureModal
					title={ordersText('delete_order')}
					content={ordersText('delete_order_content')}
					firstButton={ordersText('no_go_back')}
					secondButton={ordersText('yes_i_am')}
					showModal={isAreYouSureDeleteModalOpen}
					onClose={() => setAreYouSureDeleteModalOpen(false)}
					onSubmit={handleDeleteOrder}
				/>
			)}

			{isUpdateStatusModalOpen && orderSelected?.status &&
				<UpdateOrderStatusModal
					title={ordersText("update_status")}
					onClose={() => setIsUpdateStatusModalOpen(false)}
					showModal={isUpdateStatusModalOpen}
					initialValue={orderSelected.status}
					onSubmit={handleStatusUpdate}
				/>
			}
		</>
	)
}

export default OrdersTable